<div class="form-inline" [formGroup]="microSurveyForm">
  <div class="row">
    <div class="col-md-1">
      <label class="pull-left" style="margin-right: 15px">Suppliers</label>
    </div>
    <div class="col-sm-6 col-md-4 form-group mb-35">
      <ps-ui-select-dropdown
        [dropdownItems]="suppliers"
        [field]="'name'"
        [enableSearch]="true"
        labelNone="Select Supplier"
        [label]="selectedSupplier?.name"
        (selectedItem)="selectSupplier($event)"
      >
      </ps-ui-select-dropdown>
    </div>
  </div>

  <div class="well" *ngIf="selectedSupplier && selectedSupplierConfig">
    <div class="col-xs-12 flex-align buyer-header">
      <h4 class="text-uppercase text-center mar35">
        {{ selectedSupplier.name }}
      </h4>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-4 col-md-offset-4 row-width">
        <div class="flex-row">
          <div class="acordion-container">
            <ps-ui-accordion
              class="acordion"
              *ngFor="let section of supplierFields; index as i"
              [class.segmentation-config]="
                section.section === 'SEGMENTATION CONFIG'
              "
            >
              <ps-ui-accordion-section
                [title]="section.section"
                *ngIf="section.section === 'SEGMENTATION CONFIG'"
              >
                <div
                  class="softlaunch-toggle-btn config-tab"
                  *ngFor="let config of section.features"
                >
                  <label class="config-name-label">{{ config.name }}</label>
                  <label class="status pull-right">
                    <ps-ui-slider
                      (selectedChange)="enableSegmentConfig($event)"
                      [selected]="showSegmentSelection"
                      [disabled]="selectedSegmentParents.length > 0"
                    ></ps-ui-slider>
                  </label>
                </div>

                <div *ngIf="showSegmentSelection">
                  <hr />
                  <div class="row">
                    <label class="col-6"
                      >Segmentation Parent Qualification:</label
                    >
                    <label class="col-3">Locales:</label>
                  </div>
                  <div *ngFor="let segment of selectedSegmentParents">
                    <div class="row">
                      <ng-select
                        class="custom col-6 p-0"
                        bindLabel="name"
                        bindValue="id"
                        [items]="[segment.name]"
                        [clearable]="false"
                        [disabled]="true"
                        [searchable]="false"
                        [(ngModel)]="segment.name"
                        [ngModelOptions]="{ standalone: true }"
                      >
                      </ng-select>
                      <ng-select
                        #select
                        class="custom col-3 selected-locales p-0"
                        [searchable]="false"
                        [clearable]="false"
                        [disabled]="false"
                        [items]="segment.locales"
                        bindLabel="segment"
                        placeholder="Select Locales"
                        [multiple]="true"
                        [(ngModel)]="segment.locales"
                        [ngModelOptions]="{ standalone: true }"
                        (remove)="removeSegmentLocale($event.value, segment)"
                        (open)="select.close()"
                      >
                      </ng-select>
                      <div
                        class="col-1 text-center p-2"
                        *ngIf="segment.id && segment.locales.length"
                      >
                        <span
                          class="icons"
                          (click)="
                            updateSupplierToSegmentation('remove', segment)
                          "
                          ><i class="fa fa-close" aria-hidden="true"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <ng-select
                        class="custom col-6 p-0"
                        [clearable]="true"
                        [searchable]="true"
                        [searchFn]="customSearch"
                        label="segmentParent.name"
                        [items]="showSegmentParents"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="Select segmentation parent"
                        [(ngModel)]="selectedSegmentParentId"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="selectSegmentParent($event)"
                      >
                      </ng-select>
                      <ng-select
                        class="custom col-3 p-0"
                        [clearable]="true"
                        [searchable]="true"
                        [items]="availableSegmentLocales"
                        bindLabel="name"
                        placeholder="Select Locales"
                        [multiple]="true"
                        [(ngModel)]="segmentUpdatePayload.locales"
                        [ngModelOptions]="{ standalone: true }"
                        [closeOnSelect]="false"
                      >
                      </ng-select>
                      <div
                        class="col-1 text-center p-2"
                        *ngIf="
                          selectedSegmentParentId &&
                          segmentUpdatePayload?.locales?.length
                        "
                      >
                        <span
                          class="icons"
                          (click)="updateSupplierToSegmentation('add')"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </ps-ui-accordion-section>
              <ps-ui-accordion-section
                *ngIf="section.section !== 'SEGMENTATION CONFIG'"
                [title]="section.section"
              >
                <div class="col-xs-3" *ngFor="let config of section.features">
                  <div
                    class="softlaunch-toggle-btn config-tab"
                    *ngIf="config.value === 'supplierType'"
                  >
                    <label class="config-name-label">{{ config.name }}</label>
                    <label class="pull-right">
                      <ps-ui-capsule-radio-button
                        class="capsule-button-row"
                        [value]="selectedSupplierConfig[config.value]"
                        [onLabel]="'Private'"
                        [offLabel]="'Public'"
                        (valueChange)="
                          updateSupplierSettings(
                            $event,
                            config.value,
                            section.section
                          )
                        "
                      >
                      </ps-ui-capsule-radio-button>
                    </label>
                  </div>
                  <div
                    class="softlaunch-toggle-btn config-tab"
                    *ngIf="config.value !== 'supplierType'"
                  >
                    <label class="config-name-label">{{ config.name }}</label>
                    <div
                      *ngIf="config.value === 'cookieYesIntegration'"
                      class="setting-info"
                    >
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <p style="white-space: normal">{{ config.desc }}</p>
                    </div>

                    <label
                      class="status pull-right"
                      *ngIf="!showInput(config.value)"
                    >
                      <ps-ui-slider
                        (selectedChange)="
                          updateSupplierSettings(
                            $event,
                            config.value,
                            section.section
                          )
                        "
                        [selected]="
                          section.section === 'MICROSURVEY_SETTINGS'
                            ? microSurveyForm.value[config.value]
                            : selectedSupplierConfig[config.value]
                        "
                      ></ps-ui-slider>
                    </label>
                    <label class="pull-right" *ngIf="showInput(config.value)">
                      <input
                        type="{{
                          config.value === 'currencyName' ? 'text' : 'number'
                        }}"
                        [formControlName]="config.value"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="pull-right pb-1"
                  *ngIf="section.section === 'MICROSURVEY_SETTINGS'"
                >
                  <button
                    type="submit"
                    psUiButton
                    color="primary"
                    (click)="saveMicroSurveySettings()"
                  >
                    Save
                  </button>
                </div>
              </ps-ui-accordion-section>
            </ps-ui-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
